/* eslint-disable object-curly-newline */

/* eslint-disable camelcase */
import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ConstructorCarousel from 'components/ConstructorCarousel';
import RecServiceCarousel from 'components/RecServiceCarousel';
import { CONSTRUCTOR_PODS, INGREDIENT_PREFERENCES } from 'constants/constructorConstants';

function CleanHighlightProducts({ itemId, closeParentModal }) {
    const isRecsMigrationEnabled = Sephora.configurationSettings.recsMigration?.isEnabled;
    const params = {
        itemIds: isRecsMigrationEnabled ? [itemId] : itemId,
        ...(!isRecsMigrationEnabled && {
            filters: {
                ingredientPreferences: INGREDIENT_PREFERENCES.CLEAN_AT_SEPHORA
            }
        })
    };
    const CarouselComponent = isRecsMigrationEnabled ? RecServiceCarousel : ConstructorCarousel;

    return (
        <CarouselComponent
            podId={CONSTRUCTOR_PODS.CLEAN_HIGHLIGHT}
            params={params}
            closeParentModal={closeParentModal}
        />
    );
}

export default wrapFunctionalComponent(CleanHighlightProducts, 'CleanHighlightProducts');
